import './App.css';
import Header from './Header';
import Container from './Container';
import Footer from './footer';
function App() {
  return (
    <div>
      <Header />
      <Container/>
      <Footer />
    </div>
  );
}

export default App;
